import { Col, Container, Row } from "react-bootstrap";
import convertRupiah from "rupiah-format";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { useQuery, useMutation } from "react-query";
import { API } from "../../config/api";

import Navigasi from "../../components/Navigasi";

function DetailProduct() {
  document.title = "Detail Product";
  let navigate = useNavigate();
  let { id } = useParams();

  let { data: product, refetch } = useQuery("productCache", async () => {
    const response = await API.get("/product/" + id);
    return response.data.data;
  });

  useEffect(() => {
    const midtransScriptUrl = "https://app.sandbox.midtrans.com/snap/snap.js";
    const myMidtransClientKey = "SB-Mid-client-foc29ZY0M93h13Z7";

    let scriptTag = document.createElement("script");
    scriptTag.src = midtransScriptUrl;
    scriptTag.setAttribute("data-client-key", myMidtransClientKey);

    document.body.appendChild(scriptTag);
    return () => {
      document.body.removeChild(scriptTag);
    };
  }, []);

  const handleBuy = useMutation(async () => {
    try {
      // Get data from product

      let data = {
        idProduct: product.id,
        idSeller: product.User.id,
        price: product.price,
      };

      // Data body
      const body = JSON.stringify(data);
      // Configuration
      const config = {
        // method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.token,
          "Content-type": "application/json",
        },
        // body,
      };

      // Insert transaction data
      const response = await API.post("/transaction", body, config);
      console.log(response.data.payment.token);

      // Create variabel for store token payment from response here ...
      const token = response.data.payment.token;

      window.snap.pay(token, {
        onSuccess: function (result) {
          /* You may add your own implementation here */
          console.log(result);
          navigate("/my-profile");
        },
        onPending: function (result) {
          /* You may add your own implementation here */
          console.log(result);
          navigate("/my-profile");
        },
        onError: function (result) {
          /* You may add your own implementation here */
          console.log(result);
        },
        onClose: function () {
          /* You may add your own implementation here */
          alert("you closed the popup without finishing the payment");
        },
      });

      // Init Snap for display payment page with token here ...
    } catch (error) {
      console.log(error);
    }
  });

  return (
    <>
      <Navigasi />
      <Container className="detail-product-section">
        <Row className="d-flex justify-content-center">
          <Col md={6} className="d-flex justify-content-center">
            <img
              src={product?.image}
              alt="productImage"
              className="img-fluid"
              style={{ width: "80%" }}
            />
          </Col>
          <Col md={6}>
            <h1 className="fw-bold detail-title-product">{product?.name}</h1>
            <p className="mb-5">Stock: {product?.qty}</p>

            <p style={{ textAlign: "justify" }}>{product?.desc}</p>

            <p className="price-detail">
              {convertRupiah.convert(product?.price)}
            </p>

            <button onClick={() => handleBuy.mutate()} className="btn btn-buy">
              Buy
            </button>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default DetailProduct;
